export default __webpack_public_path__ + "static/media/kitchen3-afterD.d3d25695.jpg";